import React from 'react';
type NordenProps = {
  variant: 'pointing' | 'speechBubble' | 'full' | 'sticker';
  className?: string;
  bubbleText?: string;
};
export const Norden: React.FC<NordenProps> = ({
  variant,
  className = '',
  bubbleText
}) => {
  // This is a placeholder for the Norden mascot
  // In a real implementation, you would use actual images for the mascot
  if (variant === 'pointing') {
    return <div className={`relative ${className}`} data-id="element-487" data-mp="2fg9n01ltl2k2">
        <div className="bg-[#007AFF] rounded-full w-16 h-16 flex items-center justify-center text-white font-bold" data-id="element-488" data-mp="2feyke54420uj">
          N
        </div>
        <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-[#007AFF] rounded-full flex items-center justify-center" data-id="element-489" data-mp="2p6cokq70bou0">
          <div className="w-4 h-4 bg-[#007AFF] transform rotate-45 absolute -top-1" data-id="element-490" data-mp="2k79jx6uxvkmk"></div>
        </div>
      </div>;
  }
  if (variant === 'speechBubble') {
    return <div className={`relative ${className}`} data-id="element-491" data-mp="2y4y7wnkaz7vu">
        <div className="bg-[#007AFF] bg-opacity-10 rounded-xl p-3 text-[#007AFF]" data-id="element-492" data-mp="2t994ua92r8us">
          <p className="font-medium" data-id="element-493" data-mp="24cpnqfzl8x3y">{bubbleText || 'Hallo! Ik ben Norden!'}</p>
          <div className="absolute -bottom-2 left-5 w-4 h-4 bg-[#007AFF] bg-opacity-10 transform rotate-45" data-id="element-494" data-mp="29ar42t5mqibq"></div>
        </div>
        
      </div>;
  }
  if (variant === 'full') {
    return <div className={`relative flex items-end ${className}`} data-id="element-495" data-mp="2j96xx3w1k5ox">
        <div className="bg-[#007AFF] rounded-full w-24 h-24 flex items-center justify-center text-white font-bold text-2xl" data-id="element-496" data-mp="2jarqwp2pjgko">
          N
        </div>
        <div className="absolute top-1/2 left-20 w-8 h-8 bg-[#007AFF] rounded-full" data-id="element-497" data-mp="2s9lmcc4ay0wn"></div>
        <div className="absolute top-1/4 right-0 w-8 h-8 bg-[#007AFF] rounded-full" data-id="element-498" data-mp="2x0lkfkp5qp0q"></div>
      </div>;
  }
  // Sticker variant (small easter egg)
  return <div className={`${className}`} data-id="element-499" data-mp="31ydb6be2g53c">
      
    </div>;
};